import axios from 'axios';
import { getApiBaseUrl } from '../apiBase';

const api = axios.create({ baseURL: getApiBaseUrl() });

function authHeaders() {
  const token = localStorage.getItem('token');
  return token ? { Authorization: `Bearer ${token}` } : {};
}

export async function fetchOnboardingMy() {
  const res = await api.get('/onboarding/my', { headers: authHeaders() });
  return res.data;
}

export async function postOnboarding(path, body) {
  const res = await api.post(`/onboarding/${path}`, body ?? {}, { headers: authHeaders() });
  return res.data;
}

export async function fetchActiveSchoolSportTypeId() {
  const schoolId = localStorage.getItem('activeSchoolId');
  const params = schoolId ? { schoolId } : {};
  try {
    const res = await api.get('/school/my', { headers: authHeaders(), params });
    return res.data?.sportTypeId ?? (parseInt(localStorage.getItem('sportTypeId') || '0', 10) || null);
  } catch {
    const id = parseInt(localStorage.getItem('sportTypeId') || '0', 10);
    return id || null;
  }
}
